import { render } from "./PlatformFeeRate.vue?vue&type=template&id=1747e3fd&scoped=true"
import script from "./PlatformFeeRate.vue?vue&type=script&lang=js"
export * from "./PlatformFeeRate.vue?vue&type=script&lang=js"

import "./PlatformFeeRate.vue?vue&type=style&index=0&id=1747e3fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1747e3fd"]])

export default __exports__